import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import "../../../assets/styles/components/FullTextModal.scss"

interface FullTextModalProps {
  open: boolean;
  content: string;
  onClose: () => void;
}

function formatTextWithLineBreaks(text: string): React.ReactNode {
  return text.split(/\r\n|\n|\r/).map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));
}

const FullTextModal: React.FC<FullTextModalProps> = ({ open, content, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box className="modalBox"
      >
        <Typography>{formatTextWithLineBreaks(content)}</Typography>
        <Box mt={2} textAlign="right">
          <Typography
            component="span"
            sx={{
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={onClose}
          >
            Schließen
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default FullTextModal;
